import * as React from 'react'
import { ReceptionBookingBox } from '@modules/reception/checkin/step-payments/boxes/reception-booking-box'
import { FormInput } from '@hyper/forms'

export const ReceptionBookingCheckOutStepSettlementInvoiceNotes = (): JSX.Element => (
  <ReceptionBookingBox title="Notatka do faktury">
    <FormInput type="textarea" colSize={12} colClassName="p-0" name="invoice_note" />
  </ReceptionBookingBox>
)
